import { render, staticRenderFns } from "./EditComponents.vue?vue&type=template&id=63b31220&scoped=true"
import script from "./EditComponents.vue?vue&type=script&lang=js"
export * from "./EditComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b31220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b31220')) {
      api.createRecord('63b31220', component.options)
    } else {
      api.reload('63b31220', component.options)
    }
    module.hot.accept("./EditComponents.vue?vue&type=template&id=63b31220&scoped=true", function () {
      api.rerender('63b31220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditComponents.vue"
export default component.exports